/**
 * App actions
 */

import Constants from '../../constants';

const { Auth, User } = Constants;

/**
 * Action object dispatched when login fails
 *
 * @param {object} error error object
 */
const loginError = (error) => ({
  type: Auth.LOGIN_ERROR,
  error,
});

/**
 * Logout action object
 */
const logout = () => ({
  type: Auth.LOGOUT,
});

/**
 * Logout success action object
 */
const logoutUserSuccess = () => ({
  type: Auth.LOGOUT_SUCCESS,
});

/**
 * Action object dispatched to get current user
 */
const getCurrentUser = () => ({
  type: User.GET_CURRENT_USER,
});

/**
 * Action object dispatched to get current OneLogin user
 */
const getCurrentOneLoginUser = () => ({
  type: User.GET_CURRENT_ONELOGIN_USER,
});

/**
 * Action object dispatched when unable to get current user
 *
 * @param {object} error error object
 */
const getCurrentUserError = (error) => ({
  type: User.GET_CURRENT_USER_ERROR,
  error,
});

/**
 * Action object dispatched when current user is fetched successfully
 *
 * @param {object} action:
 * {
 *   @property {object} user: object containing user data
 *   @property {string} token: authentication token
 * }
 */
const getCurrentUserSuccess = ({ user, authToken: token }) => ({
  type: User.GET_CURRENT_USER_SUCCESS,
  user,
  token,
});

/**
 * Action object dispatched when current user is fetched successfully
 *
 * @param {object} action:
 * {
 *   @property {object} user: object containing user data
 *   @property {string} token: authentication token
 * }
 */
const getCurrentOneLoginUserSuccess = ({ user, authToken: token }) => ({
  type: User.GET_CURRENT_ONELOGIN_USER_SUCCESS,
  user,
  token,
});

/**
 * Action object dispatched when current OneLogin user is logged out successfully
 */
const logoutOneLoginUserSuccess = () => ({
  type: Auth.ONELOGIN_LOGOUT_SUCCESS,
});

/**
 * Action object dispatched when current OneLogin user is unsuccessfully logged out
 */
const logoutOneLoginUserError = () => ({
  type: Auth.ONELOGIN_LOGOUT_ERROR,
});

export default {
  loginError,
  logout,
  logoutUserSuccess,
  logoutOneLoginUserSuccess,
  logoutOneLoginUserError,
  getCurrentUser,
  getCurrentOneLoginUser,
  getCurrentUserSuccess,
  getCurrentOneLoginUserSuccess,
  getCurrentUserError,
};
